// PdfFormFill.jsx
import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { PDFDocument } from 'pdf-lib';

export default function PdfFormFill() {
  const [loading, setLoading] = React.useState(false);
  const [file, setFile] = React.useState(null);

  function onPickFile(e) {
    const f = e.target.files?.[0] || null;
    setFile(f);
  }

  async function fillBuffer(arrayBuffer) {
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const form = pdfDoc.getForm();

    // Texto
    form.getTextField('Patient Support  Monitoring Program Name').setText('Isso é um teste');
    form.getTextField('Patient Initials').setText('R.B');
    form.getTextField('Country').setText('Brasil');
    form.getCheckBox('undefined_6').check();
    form.getCheckBox('Death').check();
    form.getCheckBox('Inpatient hospitalisation required').check();

    return pdfDoc.save();
  }

  // Fluxo simples: ler arquivo local -> preencher -> BAIXAR
  async function fillAndDownload() {
    if (!file) {
      alert('Escolha um arquivo PDF primeiro.');
      return;
    }
    try {
      setLoading(true);
      const buf = await file.arrayBuffer();
      const filledBytes = await fillBuffer(buf);

      const blob = new Blob([filledBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'form-preenchido.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      console.error(err);
      alert('Erro ao preencher o PDF. Verifique os nomes dos campos.');
    } finally {
      setLoading(false);
    }
  }

  // (Opcional) Chrome/Edge: abrir e SALVAR sobre o mesmo arquivo no disco
  async function fillOpenAndSaveOnDisk() {
    if (!('showOpenFilePicker' in window)) {
      alert('Este recurso requer Chrome/Edge (File System Access API).');
      return;
    }
    try {
      setLoading(true);
      // escolher arquivo no disco
      const [handle] = await window.showOpenFilePicker({
        types: [{ description: 'PDF', accept: { 'application/pdf': ['.pdf'] } }],
        excludeAcceptAllOption: false,
        multiple: false
      });
      const file = await handle.getFile();
      const buf = await file.arrayBuffer();

      // preencher
      const filledBytes = await fillBuffer(buf);

      // salvar de volta no mesmo arquivo
      const writable = await handle.createWritable();
      await writable.write(new Blob([filledBytes], { type: 'application/pdf' }));
      await writable.close();
      alert('PDF salvo com sucesso no disco.');
    } catch (err) {
      console.error(err);
      alert('Falha ao abrir/salvar o PDF pelo disco.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <Row className="align-items-center">
        <Col sm={6} lg={6}>
          <h4 className="page-title">Formulário de Farmacovigilância</h4>
        </Col>
      </Row>

      <Card className="cardDestaque">
        <Card.Body>
          <div className="pdf-fill" style={{ display: 'grid', gap: 12 }}>
            <label>
              <strong>Escolher PDF local:</strong>{' '}
              <input type="file" accept="application/pdf,.pdf" onChange={onPickFile} />
            </label>

            <button onClick={fillAndDownload} disabled={loading || !file}>
              {loading ? 'Gerando...' : 'Preencher & Baixar'}
            </button>

            {'showOpenFilePicker' in window && (
              <button onClick={fillOpenAndSaveOnDisk} disabled={loading}>
                {loading ? 'Salvando...' : 'Abrir & Salvar no disco (Chrome/Edge)'}
              </button>
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
